// extracted by mini-css-extract-plugin
module.exports = {"wqjv1yv":"wqjv1yv"};